






























































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import CardInputResumeRalan from "./CardInputResumeRalan.vue";
import HydrationGuard from "@/mixins/HydrationGuard";
import ResumeRalan from "@/services/ResumeRalan";
import FormPrefillService from "@/services/FormPrefillService";
import SoapRanapDokter from "@/services/SoapRanapDokter";
import MasterReferensi from "@/store/modules/new/MasterReferensi";
import { storeDokter } from "@/store/modules/dokter";
import { storeResume } from "@/store/modules/resume";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { PrefillSkdp, ResumeRalanBlanko } from "@/types/resumeRalanBlanko";
import { SoapRanapResponseItem } from "@/types/soap";
import {
  blankoBaru,
  blankoDariPayload,
  blankoMasihKosong,
  dariPrefill,
  dariSoap,
  isiYangKosong,
  kosong,
  pisahPayload
} from "@/utils/resumeRalanBlanko";
import { pickSoapDokterTerakhir } from "@/utils/spriFromSoap";
import moment from "moment";

@Component({
  components: { CardInputResumeRalan },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class FormResumeRalan extends Mixins(HydrationGuard) {
  /** Form hanya memuat data saat benar-benar ditampilkan. */
  @Prop({ type: Boolean, default: false }) readonly aktif!: boolean;
  @Prop({ required: true }) readonly register!: string;
  @Prop({ default: "" }) readonly rm!: string;

  isReadOnly!: () => boolean;

  form: ResumeRalanBlanko | null = null;
  saving = false;
  menujuTtd = false;
  sumberGagal: Array<string> = [];

  get readOnlyMode(): boolean {
    return this.isReadOnly();
  }

  get terkunci(): boolean {
    return this.busy || this.saving || this.readOnlyMode;
  }

  get stateuser() {
    return userModule.user;
  }

  get adaResume(): boolean {
    return storeResume.resume.length > 0;
  }

  get listDokter() {
    return storeDokter.listAll;
  }

  get listDischarge() {
    return MasterReferensi.caraKeluar;
  }

  get bisaTtd(): boolean {
    if (!this.form || this.readOnlyMode) return false;

    return (
      this.stateuser.profesi == "Dokter" &&
      String(this.form.dpjp_id) === String(this.stateuser.id)
    );
  }

  get dpjpTerkunci(): boolean {
    const resume: any = storeResume.resume[0];
    if (!resume || !resume.dpjp) return false;

    return String(resume.dpjp.id) !== String(this.stateuser.id);
  }

  @Watch("aktif", { immediate: true })
  onBuka(val: boolean) {
    if (val) this.muatForm();
  }

  @Watch("register")
  onGantiRegister() {
    if (this.aktif) this.muatForm();
  }

  async muatForm() {
    const reg = this.register;
    if (!reg) return;

    this.form = null;
    this.sumberGagal = [];
    this.loaded = false;

    if (!this.listDischarge.length) {
      MasterReferensi.getCaraKeluarList().catch(() => undefined);
    }

    if (!this.listDokter.length) {
      storeDokter.act_dokter_all();
    }

    await this.hydrate(async () => {
      await storeResume.act_resume_on_reg({ reg, idUser: "" });
      if (String(reg) !== String(this.register)) return;

      this.form = storeResume.resume.length
        ? blankoDariPayload(storeResume.resume[0])
        : blankoBaru();

      if (!this.form.dpjp_id) {
        this.form.dpjp_id = this.stateuser.id;
      }

      if (blankoMasihKosong(this.form)) {
        await this.tarikDariRme(reg);
      } else {
        await this.isiDariSoap(reg);
      }
    });
  }

  async soapTerakhir(
    reg: string
  ): Promise<SoapRanapResponseItem | null | undefined> {
    const resp = await SoapRanapDokter.getByRegister(reg).catch(() => undefined);
    if (!resp) return undefined;

    return pickSoapDokterTerakhir(resp.data || [], reg);
  }

  async isiDariSoap(reg: string) {
    const soap = await this.soapTerakhir(reg);
    if (String(reg) !== String(this.register) || !this.form) return;

    if (soap === undefined) this.sumberGagal = ["SOAP"];

    isiYangKosong(this.form, dariSoap(soap));
  }

  async lengkapiDariRme() {
    const terisi = await this.tarikDariRme(this.register);

    if (terisi && terisi.length) {
      appModule.NoticeDelay("Terisi: " + terisi.join(", "));
    } else {
      appModule.NoticeDelay("Tidak ada kolom kosong yang dapat diisi otomatis");
    }
  }

  async tarikDariRme(reg: string): Promise<Array<string>> {
    if (!this.form) return [];

    const hasil = await Promise.all([
      FormPrefillService.fetchPrefill(this.rm, "resume_ralan", {
        register_id: reg,
        unit_id: this.stateuser.unit_id,
        sources: ["anamnesis_terkini", "klinis_terkini"]
      }).catch(() => null),
      this.soapTerakhir(reg)
    ]);

    if (String(reg) !== String(this.register) || !this.form) return [];

    const prefill: any = hasil[0];
    const soap = hasil[1];

    const gagal: Array<string> = [];
    if (!prefill) gagal.push("anamnesis & TTV");
    if (soap === undefined) gagal.push("SOAP");
    this.sumberGagal = gagal;

    const terisi = isiYangKosong(this.form, dariPrefill(prefill ? prefill.fields : null));

    const terisiLain = isiYangKosong(this.form, {
      ...dariSoap(soap),
      tgl_surat: moment().format("YYYY-MM-DD")
    });

    return terisi.concat(terisiLain);
  }

  /**
   * `umumkan = false` dipakai jalur "Buat SKDP": tanpa itu emit `tersimpan`
   * menutup form di kartu induk dan MENGHANCURKAN komponen ini, sehingga emit
   * `buat-skdp` sesudahnya lahir dari komponen mati dan tak pernah sampai.
   */
  async simpan(umumkan = true, ttd = false): Promise<boolean> {
    if (!this.form) return false;

    const valid = (this.$refs.form as any).validate();
    if (!valid) return false;

    const resume: any = storeResume.resume[0];
    if (resume && String(resume.signed) === "1") {
      const lanjut = window.confirm(
        "Resume ini sudah ditandatangani. Menyimpan perubahan akan membatalkan tanda tangan. Lanjutkan?"
      );
      if (!lanjut) return false;
    }

    this.saving = true;
    this.menujuTtd = ttd;

    try {
      const { paket, blanko } = pisahPayload(this.form);

      const dt: any = await ResumeRalan.saveForm(this.register, {
        ...paket,
        ...blanko,
        pasien_rm: this.rm
      });

      const body = dt && dt.data ? dt.data : null;

      if (!body || String(body.status) !== "1") {
        appModule.sendErrorAlert(
          body && body.message ? body.message : "Gagal simpan resume"
        );

        return false;
      }

      await storeResume.act_resume_on_reg({ reg: this.register, idUser: "" });

      appModule.NoticeDelay("Berhasil Simpan Resume Rawat Jalan");

      if (umumkan) {
        this.$emit("tersimpan", {
          discharge_id: body.data ? body.data.discharge_id : this.form.discharge_id,
          ttd
        });
      }

      return true;
    } finally {
      this.saving = false;
      this.menujuTtd = false;
    }
  }

  async simpanDanTtd() {
    if (!this.form) return;

    if (kosong(this.form.diagnosa_akhir)) {
      appModule.sendErrorAlert(
        "Diagnosa Akhir harus diisi sebelum resume ditandatangani"
      );

      return;
    }

    await this.simpan(true, true);
  }

  async teruskanSkdp(payload: PrefillSkdp) {
    const tersimpan = await this.simpan(false);
    if (!tersimpan) return;

    this.$emit("buat-skdp", payload);
  }

  batal() {
    this.$emit("batal");
  }
}
